<template>
    <div>
        <main-navigation></main-navigation>
        <centered-card headline="Edit your Blog">
            <blog-form edit="true" :blog="blog" />
        </centered-card>
    </div>
</template>

<script>

    import MainNavigation from '../../layout/MainNavigation.vue';
    import CenteredCard from '../../layout/CenteredCard.vue'
    import BlogForm from './BlogForm.vue';

    export default {
        name: 'UserBlogEditPage',
        metaInfo: {
            title: 'Edit your Blog'
        },
        data() {
            return {
                blog: {}
            }
        },
        created() {
            this.$api.getBlog(this.$route.params.blogUrl).then((res)=>{
                this.blog = res.data.blog;
            });
        },
        methods: {},
        components: {
            MainNavigation,
            CenteredCard,
            BlogForm
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/components/user/blogs/UserBlogEdit.vue